<div class="container vehicle-data-container">
    <div class="container__title vehicle-data-container__title">
        {{ 'SHORTENED-VEHICLE_COMPONENT.header' | translate}}
    </div>
    <div class="vehicle-data-container__content">
        <ng-container *ngIf="ownerData.firstName && ownerData.lastName">{{ ownerData.firstName }} {{ ownerData.lastName }},&nbsp;</ng-container>
        <ng-container *ngIf="showRegistrationNumber">{{ vehicleData.registrationNumber }},&nbsp;</ng-container>
        <ng-container>{{ vehicleModelState?.brandName }} {{ vehicleModelState?.modelName }},&nbsp;</ng-container>
        <ng-container>{{ vehicleData.productionYear }}&nbsp;</ng-container>
    </div>
    <div class="right-arrow-btn-wrapper">
        <button class="btn btn--clear btn--no-outline" (click)="backToVehicleData()">
            {{ buttonLabel | translate }}
            <span class="material-icons">arrow_right</span>
        </button>
    </div>
</div>
